module.exports = __webpack_public_path__ + "static/media/built-in-austin.46f95699.png";